// ABOUTME: Publishes the active tenant or public i18next instance to every translation consumer.
// ABOUTME: Changes context without remounting the application or sharing stores across paths.
import React from "react";
import { I18nextProvider } from "react-i18next";
import { getTranslationInstance, subscribeTranslationInstance } from "./i18n";

const TranslationProvider = ({
    children
}: {
    children: React.ComponentProps<typeof I18nextProvider>["children"];
}) => {
    const [instance, setInstance] = React.useState(getTranslationInstance);

    React.useLayoutEffect(() => {
        const updateInstance = () => setInstance(getTranslationInstance());
        const unsubscribe = subscribeTranslationInstance(updateInstance);
        // A child can configure its path during mount before this subscription.
        updateInstance();
        return unsubscribe;
    }, []);

    return <I18nextProvider i18n={instance}>{children}</I18nextProvider>;
};

export default TranslationProvider;
